import { getChannel, handleAllMessages, subscribe } from './adapted-services.ts'

export const realtimeClientService = {
  getChannel,
  handleAllMessages,
  subscribe,
}
